import { UserService, DomesticService } from "Services";
import { ModalUtilities } from "Utilities";
import GeneralLoader from "Utilities/GeneralLoader";
import "./DomesticWaybillModalComponent.ts";

class DomesticWaybillModal {
  openModal = (bookingNo: string, customerReference: string) => {
    const resolve = {
      transport: async function transport() {
        const currentUser = UserService.getUserProfile();
        const selectedCompany = UserService.getSelectedCompany();
        if (!currentUser) return;
        GeneralLoader.increase();
        return DomesticService.getDomesticBookingWayBill(
          selectedCompany.CompanyRegNo,
          bookingNo,
          customerReference
        ).finally(() => {
          GeneralLoader.decrease();
        });
      },
    };

    ModalUtilities.showExtraLargeModal("domesticWaybillModal", resolve);
  };
}
export default new DomesticWaybillModal();
